import { render, staticRenderFns } from "./FlockCardHeader.vue?vue&type=template&id=614f2841&scoped=true&"
import script from "./FlockCardHeader.vue?vue&type=script&lang=js&"
export * from "./FlockCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./FlockCardHeader.vue?vue&type=style&index=0&id=614f2841&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614f2841",
  null
  
)

export default component.exports